{
  "v5.architecture.annuler": "Annuler",
  "v5.architecture.annuler.bouton": "Confirmer l’annulation",
  "v5.architecture.annuler.rappel": "{{numero}} — {{titre}} sera annulée ; le motif est conservé.",
  "v5.architecture.annuler.titre": "Annuler une décision d’architecture",
  "v5.architecture.arc.ajoutes": "{{section}} ajoutés : {{liste}}",
  "v5.architecture.arc.aucun_ecart": "Aucun écart : les deux références sont identiques.",
  "v5.architecture.arc.bouton_comparer": "Comparer",
  "v5.architecture.arc.bouton_figer": "Figer la ligne de base",
  "v5.architecture.arc.cible": "Comparer avec",
  "v5.architecture.arc.cible_ligne": "Ligne de base « {{nom}} »",
  "v5.architecture.arc.cible_version": "État de la version {{version}}",
  "v5.architecture.arc.comparer_titre": "Comparer",
  "v5.architecture.arc.ecarts": "Écarts",
  "v5.architecture.arc.ecarts_libelle": "les écarts",
  "v5.architecture.arc.ecarts_vide": "Choisissez deux références, puis comparez.",
  "v5.architecture.arc.figee": "Ligne de base « {{nom}} » figée (horodatage sans valeur légale).",
  "v5.architecture.arc.figer": "Figer une ligne de base",
  "v5.architecture.arc.ligne_auteur": "Figée par",
  "v5.architecture.arc.ligne_date": "Le",
  "v5.architecture.arc.ligne_nom": "Nom",
  "v5.architecture.arc.ligne_reference": "Ligne de base",
  "v5.architecture.arc.ligne_version": "Version",
  "v5.architecture.arc.lignes": "Lignes de base",
  "v5.architecture.arc.lignes_libelle": "les lignes de base",
  "v5.architecture.arc.lignes_vide": "Aucune ligne de base figée.",
  "v5.architecture.arc.modifies": "{{section}} modifiés : {{liste}}",
  "v5.architecture.arc.nom_ligne": "Nom de la ligne de base",
  "v5.architecture.arc.ouvrir": "Ouvrir l’architecture de la version",
  "v5.architecture.arc.perimetre": "Périmètre",
  "v5.architecture.arc.perimetre.architecture": "Architecture de la version (composants, dépendances, technologies)",
  "v5.architecture.arc.references": "Références à comparer",
  "v5.architecture.arc.retires": "{{section}} retirées : {{liste}}",
  "v5.architecture.arc.section.composants": "Composants",
  "v5.architecture.arc.section.dependances": "Dépendances",
  "v5.architecture.arc.section.technologies": "Technologies",
  "v5.architecture.arc.titre": "Architecture de l’application livrée",
  "v5.architecture.arc.version": "Version livrée",
  "v5.architecture.arc.version_a_figer": "Version à figer",
  "v5.architecture.arc.version_option": "{{version}} — {{composants}} composants",
  "v5.architecture.arc.versions": "Versions livrées",
  "v5.architecture.arc.versions_libelle": "les versions livrées",
  "v5.architecture.arc.versions_vide": "Aucune version livrée dans ce projet.",
  "v5.architecture.champ.contexte": "Contexte",
  "v5.architecture.champ.motif": "Motif",
  "v5.architecture.champ.probleme": "Problème",
  "v5.architecture.champ.probleme_aide": "Rangé dans le contexte, section « Problème ».",
  "v5.architecture.champ.sujet": "Sujet",
  "v5.architecture.champ.titre": "Titre",
  "v5.architecture.code.ACCESS_REQUEST_ALREADY_MEMBER": "Vous êtes déjà membre du projet.",
  "v5.architecture.code.ACCESS_REQUEST_ALREADY_PENDING": "Une demande est déjà en attente.",
  "v5.architecture.code.ACCESS_REQUEST_NOT_MEMBER": "Une extension de droit suppose d’être membre du projet.",
  "v5.architecture.code.ACCESS_REQUEST_RIGHT_ALREADY_HELD": "Vous tenez déjà ce droit.",
  "v5.architecture.code.ADR_ALREADY_REVIEWED": "Déjà relue : une nouvelle revue suit une nouvelle révision.",
  "v5.architecture.code.ADR_ANNULATION_HORS_ETAT": "Seule une décision en préparation ou décidée s’annule.",
  "v5.architecture.code.ADR_DECIDED_IMMUTABLE": "Décision déjà décidée : elle ne se modifie plus.",
  "v5.architecture.code.ADR_ISSUE_MOTIF_REQUIS": "Sans option retenue, le motif est obligatoire.",
  "v5.architecture.code.ADR_NUMBER_EXISTS": "Ce numéro de décision existe déjà dans le projet.",
  "v5.architecture.code.ADR_REVIEWER_CANNOT_DECIDE": "Qui a relu la décision ne la décide pas.",
  "v5.architecture.code.ADR_SELF_DECISION_REFUSED": "L’auteur ne décide pas sa propre décision.",
  "v5.architecture.code.ADR_SELF_REVIEW_REFUSED": "L’auteur ne relit pas sa propre décision.",
  "v5.architecture.code.ADR_SUPERSEDE_NOT_DECIDED": "Remplacement impossible : les deux décisions doivent être décidées.",
  "v5.architecture.code.ADR_TRIANGLE_REVIEW_REQUIRED": "Décision difficilement réversible : une revue favorable distincte est requise.",
  "v5.architecture.code.ADR_WEIGHTS_FROZEN": "Critères figés depuis la première note.",
  "v5.architecture.code.CONTEXTE_INCOMPLET": "Le contexte du projet est incomplet : le geste est refusé.",
  "v5.architecture.code.CREATEUR_N_APPROUVE_PAS": "Séparation des tâches : l’auteur ne valide pas son propre travail.",
  "v5.architecture.code.DROIT_NON_TENU": "Vous ne tenez pas le droit requis pour ce geste.",
  "v5.architecture.code.GARDE_DROIT_ABSENTE": "Cette opération n’a pas de garde de droit : refusée par défaut.",
  "v5.architecture.code.LIGNE_DE_BASE_INTROUVABLE": "Ligne de base introuvable dans ce projet.",
  "v5.architecture.code.LIGNE_DE_BASE_NOM_DEJA_UTILISE": "Ce nom de ligne de base est déjà utilisé dans le projet.",
  "v5.architecture.code.MODELE_V10_INCOHERENT": "Le modèle du projet est incohérent : l’écran ne peut pas s’afficher.",
  "v5.architecture.code.NOT_FOUND": "Introuvable dans ce projet.",
  "v5.architecture.code.RELEASE_NOT_FOUND": "Version introuvable dans ce projet.",
  "v5.architecture.code.RELECTEUR_NE_DECIDE_PAS": "Séparation des tâches : qui a relu ne décide pas.",
  "v5.architecture.code.REPRISE_PREUVE_MANQUANTE": "Validation impossible : une preuve attendue n’est pas fournie.",
  "v5.architecture.code.RESOURCE_UNAVAILABLE": "Décision introuvable dans ce projet.",
  "v5.architecture.code.SANS_SESSION": "Session expirée : reconnectez-vous.",
  "v5.architecture.code.TECH_BASELINE_CHANGE_REQUIRED": "Cette catégorie est fixée par la baseline : passez par un changement technologique.",
  "v5.architecture.code.TECH_CHANGE_REWORK_OPEN": "Des reprises restent à faire.",
  "v5.architecture.code.VALIDATION_ERROR": "La saisie est incomplète ou invalide.",
  "v5.architecture.code.WORKSPACE_ARCHIVED": "Le projet est archivé : il se lit seulement.",
  "v5.architecture.composant.aucun": "Aucun composant désigné.",
  "v5.architecture.composant.depend": "Dépend de : {{liste}}",
  "v5.architecture.composant.entete": "{{nom}} ({{nature}})",
  "v5.architecture.composant.fichiers": "Fichiers",
  "v5.architecture.composant.libelle": "le composant",
  "v5.architecture.composant.lignes": "Lignes",
  "v5.architecture.composant.relations": "Relations du composant",
  "v5.architecture.composant.retour": "Retour à l’architecture de la version",
  "v5.architecture.composant.routes": "Routes",
  "v5.architecture.composant.sans_relation": "Aucune relation relevée.",
  "v5.architecture.composant.technologie": "Technologie",
  "v5.architecture.composant.titre": "Composant d’une version livrée",
  "v5.architecture.composant.utilise_par": "Utilisé par : {{liste}}",
  "v5.architecture.creer.bouton": "Créer la décision",
  "v5.architecture.creer.titre": "Créer une décision d’architecture",
  "v5.architecture.decider.auteur": "Préparée par {{auteur}} : décidée par un tiers.",
  "v5.architecture.decider.bouton": "Confirmer la décision",
  "v5.architecture.decider.commentaire": "Commentaire de décision",
  "v5.architecture.decider.commentaire_requis": "Commentaire obligatoire (motif si aucune option n’est retenue).",
  "v5.architecture.decider.deja": "Cette décision n’est plus à décider.",
  "v5.architecture.decider.issue": "Issue",
  "v5.architecture.decider.issue.aucune_option": "Aucune option n’est retenue",
  "v5.architecture.decider.issue.option_retenue": "Une option est retenue",
  "v5.architecture.decider.option": "Option retenue",
  "v5.architecture.decider.recapitulatif": "Récapitulatif",
  "v5.architecture.decider.relecteur": "Qui a relu cette décision ne la décide pas.",
  "v5.architecture.decider.sans_option": "Aucune option à retenir : seule l’issue « aucune option » est possible.",
  "v5.architecture.decider.titre": "Confirmer la décision d’architecture",
  "v5.architecture.droit.a_preciser": "Aucun droit n’est désigné : revenez depuis l’élément grisé qui l’exige.",
  "v5.architecture.droit.circuit": "Circuit",
  "v5.architecture.droit.circuit_aucun": "Aucun profil du projet n’attribue ce droit : la demande ne peut aboutir.",
  "v5.architecture.droit.circuit_chargement": "Recherche des profils qui attribuent ce droit…",
  "v5.architecture.droit.circuit_non_divulguable": "Les profils qui attribuent ce droit ne sont pas divulgués.",
  "v5.architecture.droit.circuit_profils": "Attribution par une personne habilitée : {{profils}}.",
  "v5.architecture.droit.doublon": "Une demande pour ce droit est déjà en attente.",
  "v5.architecture.droit.duree": "Durée",
  "v5.architecture.droit.duree_texte": "Permanente jusqu’au retrait par une personne habilitée ; vous ne vous l’attribuez jamais vous-même.",
  "v5.architecture.droit.effet.immediat": "Aucun droit n’est accordé tant qu’une personne habilitée n’a pas décidé.",
  "v5.architecture.droit.effet.separation": "La séparation des tâches s’applique toujours, même une fois le droit accordé.",
  "v5.architecture.droit.effet.suivi": "Vous suivez votre demande depuis « Accès au projet ».",
  "v5.architecture.droit.effets": "Effets",
  "v5.architecture.droit.envoyer": "Envoyer la demande",
  "v5.architecture.droit.extension": "Extension de droit : vous restez membre du projet avec vos profils actuels.",
  "v5.architecture.droit.identifie": "Droit demandé : {{libelle}}",
  "v5.architecture.droit.motif_aide": "Dites pourquoi ce droit vous est nécessaire.",
  "v5.architecture.droit.portee": "Portée de la demande",
  "v5.architecture.droit.portee_libelle": "vos demandes en cours",
  "v5.architecture.droit.requis": "Droit requis",
  "v5.architecture.droit.titre": "Solliciter un droit supplémentaire",
  "v5.architecture.editeur.ajouter_critere": "Ajouter le critère",
  "v5.architecture.editeur.ajouter_option": "Ajouter l’option",
  "v5.architecture.editeur.critere": "Critère",
  "v5.architecture.editeur.critere_de_note": "Critère noté",
  "v5.architecture.editeur.critere_libelle": "Libellé du critère",
  "v5.architecture.editeur.criteres": "Critères",
  "v5.architecture.editeur.donnees": "Données de la décision",
  "v5.architecture.editeur.echoue": "Échoué (option exclue)",
  "v5.architecture.editeur.enregistre": "Décision enregistrée.",
  "v5.architecture.editeur.enregistrer": "Enregistrer",
  "v5.architecture.editeur.enregistrer_note": "Enregistrer la note",
  "v5.architecture.editeur.enregistrer_poids": "Enregistrer le poids",
  "v5.architecture.editeur.exclue": "Écartée : {{motif}}",
  "v5.architecture.editeur.figee": "Cette décision n’est plus en préparation : elle se lit depuis sa fiche.",
  "v5.architecture.editeur.figes": "Critères figés depuis la première note.",
  "v5.architecture.editeur.incomplete": "Notes incomplètes",
  "v5.architecture.editeur.justification": "Justification",
  "v5.architecture.editeur.matrice": "Options, critères et notes",
  "v5.architecture.editeur.nature": "Nature du critère",
  "v5.architecture.editeur.nature.mandatory": "Obligatoire, réussi ou échoué",
  "v5.architecture.editeur.nature.weighted": "Pondéré, noté de 1 à 5",
  "v5.architecture.editeur.note": "Note (1 à 5)",
  "v5.architecture.editeur.note_hors_bornes": "Une note va de 1 à 5.",
  "v5.architecture.editeur.notes": "Notes",
  "v5.architecture.editeur.nouveau_poids": "Nouveau poids",
  "v5.architecture.editeur.option_a_noter": "Option à noter",
  "v5.architecture.editeur.option_description": "Description de l’option",
  "v5.architecture.editeur.option_libelle": "Libellé de l’option",
  "v5.architecture.editeur.options": "Options",
  "v5.architecture.editeur.poids_initial": "Poids initial",
  "v5.architecture.editeur.retour": "Retour à la fiche",
  "v5.architecture.editeur.reussi": "Réussi",
  "v5.architecture.editeur.sans_option": "Aucune option pour le moment.",
  "v5.architecture.editeur.score": "Score pondéré",
  "v5.architecture.editeur.titre": "Préparer une décision d’architecture",
  "v5.architecture.editeur.total_poids": "Total des poids pondérés : {{total}} (attendu : 100)",
  "v5.architecture.editeur.verdict": "Verdict",
  "v5.architecture.etat.chargement": "Chargement de {{quoi}}…",
  "v5.architecture.etat.erreur": "{{quoi}} : lecture impossible pour le moment.",
  "v5.architecture.etat.reessayer": "Réessayer",
  "v5.architecture.etat.refus": "{{quoi}} : lecture refusée.",
  "v5.architecture.fermer": "Fermer",
  "v5.architecture.fiche.annulation": "Annulée par {{par}} le {{date}} : {{motif}}",
  "v5.architecture.fiche.annuler": "Annuler la décision…",
  "v5.architecture.fiche.aucune_option": "Aucune option retenue : {{motif}}",
  "v5.architecture.fiche.auteur": "Préparée par {{auteur}} le {{date}}",
  "v5.architecture.fiche.contexte": "Contexte",
  "v5.architecture.fiche.decider": "Décider…",
  "v5.architecture.fiche.decideur": "Décidée par {{par}} le {{date}}",
  "v5.architecture.fiche.issue": "Option retenue et issue",
  "v5.architecture.fiche.libelle": "la décision d’architecture",
  "v5.architecture.fiche.option_retenue": "Option retenue : {{option}}",
  "v5.architecture.fiche.preparer": "Préparer",
  "v5.architecture.fiche.remplace": "Remplace {{numero}}",
  "v5.architecture.fiche.remplacee_par": "Remplacée par {{numero}}",
  "v5.architecture.fiche.remplacement_motif": "Motif du remplacement : {{motif}}",
  "v5.architecture.fiche.remplacer": "Remplacer…",
  "v5.architecture.fiche.retour_liste": "Retour aux décisions",
  "v5.architecture.fiche.revoir": "Relire",
  "v5.architecture.fiche.revue": "Tour {{tour}} — {{relecteur}} : {{verdict}}",
  "v5.architecture.fiche.revues": "Revues",
  "v5.architecture.fiche.sans_issue": "Aucune option retenue pour le moment.",
  "v5.architecture.fiche.sans_predecesseur": "Sans prédécesseur",
  "v5.architecture.fiche.sans_remplacement": "Sans remplacement",
  "v5.architecture.fiche.sans_revue": "Aucune revue pour le moment.",
  "v5.architecture.fiche.sujet": "Sujet : {{sujet}}",
  "v5.architecture.fiche.titre": "Décision d’architecture",
  "v5.architecture.geste.erreur": "Le geste n’a pas abouti. Réessayez dans un instant.",
  "v5.architecture.heritage.col.categorie": "Catégorie",
  "v5.architecture.heritage.col.ecart": "Écart",
  "v5.architecture.heritage.col.herite": "Choix hérité",
  "v5.architecture.heritage.col.origine": "Origine",
  "v5.architecture.heritage.col.projet": "Choix du projet",
  "v5.architecture.heritage.compte": "{{n}} écart(s) avec l’héritage.",
  "v5.architecture.heritage.ecart.different": "Différent",
  "v5.architecture.heritage.ecart.identique": "Identique",
  "v5.architecture.heritage.ecart.projet_non_defini": "Absent du projet",
  "v5.architecture.heritage.ecart.sans_heritage": "Sans héritage",
  "v5.architecture.heritage.libelle": "la comparaison avec l’héritage",
  "v5.architecture.heritage.non_defini": "—",
  "v5.architecture.heritage.origine.aucune": "Choix propre",
  "v5.architecture.heritage.origine.organisation": "Organisation",
  "v5.architecture.heritage.origine.programme": "Programme",
  "v5.architecture.heritage.source": "Hérité de",
  "v5.architecture.heritage.source.organisation": "Organisation ({{id}})",
  "v5.architecture.heritage.source.program": "Programme parent ({{id}}, version {{version}})",
  "v5.architecture.heritage.tableau": "Comparaison avec les choix hérités",
  "v5.architecture.heritage.titre": "Comparer les choix technologiques hérités",
  "v5.architecture.heritage.version": "Version comparée",
  "v5.architecture.heritage.version_courante": "Version courante du projet ({{version}})",
  "v5.architecture.heritage.vide": "Aucune catégorie technologique à comparer.",
  "v5.architecture.liste.libelle": "les décisions du projet",
  "v5.architecture.liste.nouvelle": "Nouvelle décision",
  "v5.architecture.liste.numero": "Décision",
  "v5.architecture.liste.option": "Option retenue",
  "v5.architecture.liste.statut": "Statut",
  "v5.architecture.liste.technologies": "Choix et baseline technologiques",
  "v5.architecture.liste.titre": "Décisions d’architecture du projet",
  "v5.architecture.liste.vide": "Aucune décision d’architecture dans ce projet.",
  "v5.architecture.onglet.outil": "Outil",
  "v5.architecture.onglet.projet": "Projet",
  "v5.architecture.onglets.decisions": "Portée des décisions",
  "v5.architecture.outil.contexte": "Contexte",
  "v5.architecture.outil.decision": "Décision",
  "v5.architecture.outil.fiche_libelle": "la décision de l’outil",
  "v5.architecture.outil.fiche_titre": "Décision de l’outil",
  "v5.architecture.outil.libelle": "les décisions de l’outil",
  "v5.architecture.outil.options": "Options",
  "v5.architecture.outil.portee": "Consultation seule : les décisions de l’outil s’administrent depuis la plateforme.",
  "v5.architecture.outil.retenue": "{{option}} (retenue)",
  "v5.architecture.outil.retour": "Retour aux décisions de l’outil",
  "v5.architecture.outil.sans_decision": "Pas encore décidée.",
  "v5.architecture.outil.titre": "Décisions de l’outil",
  "v5.architecture.outil.vide": "Aucune décision de l’outil n’est publiée.",
  "v5.architecture.personne.inconnue": "une personne du projet",
  "v5.architecture.pile.adr": "Décidée par {{adr}}",
  "v5.architecture.pile.libelle": "le profil de pile",
  "v5.architecture.pile.qualification": "Qualification : {{etat}}",
  "v5.architecture.pile.retenu": "Pile retenue : {{pile}}",
  "v5.architecture.pile.source.baseline": "Source : baseline technologique du projet",
  "v5.architecture.pile.source.stack_profile": "Source : décision de pile",
  "v5.architecture.pile.titre": "Profil de pile du projet",
  "v5.architecture.pile.vide": "Aucun profil de pile retenu pour ce projet.",
  "v5.architecture.remplacer.aucune": "Aucune autre décision décidée du projet ne peut la remplacer.",
  "v5.architecture.remplacer.bouton": "Confirmer le remplacement",
  "v5.architecture.remplacer.choisir": "Choisir une décision",
  "v5.architecture.remplacer.libelle": "les décisions du projet",
  "v5.architecture.remplacer.remplacante": "Décision remplaçante",
  "v5.architecture.remplacer.titre": "Remplacer une décision d’architecture",
  "v5.architecture.reprise.ajouter": "Ajouter la reprise",
  "v5.architecture.reprise.ajouter_titre": "Ajouter un élément de reprise",
  "v5.architecture.reprise.changement": "Changement {{ref}}",
  "v5.architecture.reprise.changement_libelle": "le changement technologique",
  "v5.architecture.reprise.element": "Élément concerné",
  "v5.architecture.reprise.element_aucun": "Aucun",
  "v5.architecture.reprise.elements_libelle": "les éléments du projet",
  "v5.architecture.reprise.ensemble": "Le responsable et la preuve attendue vont ensemble.",
  "v5.architecture.reprise.ligne": "{{titre}} — {{statut}}",
  "v5.architecture.reprise.membres_libelle": "les membres du projet",
  "v5.architecture.reprise.non_regression": "Déclaration de non-régression",
  "v5.architecture.reprise.panneau": "Reprises et preuves",
  "v5.architecture.reprise.partie": "Vous êtes auteur ou responsable d’une reprise de ce changement : un tiers la valide.",
  "v5.architecture.reprise.preuve_attendue": "Preuve attendue",
  "v5.architecture.reprise.preuve_de": "Preuve attendue : {{preuve}}",
  "v5.architecture.reprise.preuve_fournie": "Preuve fournie pour « {{titre}} »",
  "v5.architecture.reprise.preuve_fournie_de": "Preuve fournie : {{preuve}}",
  "v5.architecture.reprise.responsable": "Responsable",
  "v5.architecture.reprise.responsable_aucun": "Sans responsable",
  "v5.architecture.reprise.responsable_de": "Responsable : {{nom}}",
  "v5.architecture.reprise.statut.done": "Terminée",
  "v5.architecture.reprise.statut.in_progress": "En cours",
  "v5.architecture.reprise.statut.in_review": "En relecture",
  "v5.architecture.reprise.statut.todo": "À faire",
  "v5.architecture.reprise.tiers": "Un tiers, ni auteur ni responsable d’une reprise, valide.",
  "v5.architecture.reprise.travail": "Travail à effectuer",
  "v5.architecture.reprise.valider": "Valider la reprise",
  "v5.architecture.reprise.verifier_titre": "Valider la reprise par un tiers",
  "v5.architecture.reprise.vide": "Aucune reprise pour ce changement.",
  "v5.architecture.retour_vue_projet": "Retour à la vue du projet",
  "v5.architecture.revoir.approuver": "Approuver",
  "v5.architecture.revoir.auteur": "L’auteur ne relit pas sa décision.",
  "v5.architecture.revoir.bouton": "Enregistrer la revue",
  "v5.architecture.revoir.commentaire": "Commentaire de revue",
  "v5.architecture.revoir.commentaire_requis": "Un rejet dit pourquoi : commentaire obligatoire.",
  "v5.architecture.revoir.conclusion": "Conclusion de la revue",
  "v5.architecture.revoir.precedentes": "Revues précédentes (conservées)",
  "v5.architecture.revoir.rejeter": "Rejeter",
  "v5.architecture.revoir.titre": "Relire une décision d’architecture",
  "v5.architecture.sans_projet": "Choisissez un projet pour voir son architecture et ses décisions.",
  "v5.architecture.statut.cancelled": "Annulée",
  "v5.architecture.statut.decided": "Décidée",
  "v5.architecture.statut.deprecated": "Dépréciée",
  "v5.architecture.statut.en_relecture": "En relecture",
  "v5.architecture.statut.proposed": "En préparation",
  "v5.architecture.statut.superseded": "Remplacée",
  "v5.architecture.sujet.database": "Base de données",
  "v5.architecture.sujet.engine": "Moteur",
  "v5.architecture.sujet.irreversible": "Décision difficilement réversible : ses conséquences sur la pile, le moteur ou la base sont à écrire dans le contexte.",
  "v5.architecture.sujet.other": "Autre",
  "v5.architecture.sujet.stack": "Pile",
  "v5.architecture.verdict.approve": "approuvée",
  "v5.architecture.verdict.reject": "rejetée",
  "v5.architecture.version.api_confirmee": "Confirmée par le relevé",
  "v5.architecture.version.api_non_confirmee": "Non confirmée",
  "v5.architecture.version.api_sans_releve": "Sans relevé",
  "v5.architecture.version.api_vide": "Aucune API exposée relevée.",
  "v5.architecture.version.aucun_service": "Aucun SBOM de service pour cette version.",
  "v5.architecture.version.choix_requis": "Plusieurs services : choisissez lequel télécharger.",
  "v5.architecture.version.col.chemin": "Chemin",
  "v5.architecture.version.col.composant": "Composant",
  "v5.architecture.version.col.contrat": "Contrat",
  "v5.architecture.version.col.corrigee": "Version corrigée",
  "v5.architecture.version.col.depend": "Dépend de",
  "v5.architecture.version.col.dependance": "Dépendance",
  "v5.architecture.version.col.gravite": "Gravité",
  "v5.architecture.version.col.identifiant": "Identifiant",
  "v5.architecture.version.col.methode": "Méthode",
  "v5.architecture.version.col.nature": "Nature",
  "v5.architecture.version.col.paquet": "Paquet",
  "v5.architecture.version.col.relation": "Relation",
  "v5.architecture.version.col.technologie": "Technologie",
  "v5.architecture.version.col.utilisee_par": "Utilisée par",
  "v5.architecture.version.col.version": "Version",
  "v5.architecture.version.composants_vide": "Aucun composant relevé pour cette version.",
  "v5.architecture.version.dependances_resume": "{{total}} dépendances : {{direct}} directes, {{transitive}} transitives, {{system}} système.",
  "v5.architecture.version.dependances_version": "Dépendances de la version",
  "v5.architecture.version.dependances_vide": "Aucune dépendance ne correspond aux filtres.",
  "v5.architecture.version.entete": "Version {{version}} — {{titre}}",
  "v5.architecture.version.fiches_dependances": "Fiches des dépendances",
  "v5.architecture.version.libelle": "l’architecture de la version",
  "v5.architecture.version.nom_contient": "Nom contient",
  "v5.architecture.version.onglet.api": "API",
  "v5.architecture.version.onglet.composants": "Composants",
  "v5.architecture.version.onglet.dependances": "Dépendances",
  "v5.architecture.version.onglet.vulnerabilites": "Vulnérabilités",
  "v5.architecture.version.onglets": "Vues de la version",
  "v5.architecture.version.relation": "Relation",
  "v5.architecture.version.relation.direct": "Directe",
  "v5.architecture.version.relation.system": "Système",
  "v5.architecture.version.relation.toutes": "Toutes",
  "v5.architecture.version.relation.transitive": "Transitive",
  "v5.architecture.version.retour": "Retour aux versions",
  "v5.architecture.version.revision_service": "Révision et service du SBOM",
  "v5.architecture.version.sans_composant": "—",
  "v5.architecture.version.sbom": "Télécharger le SBOM",
  "v5.architecture.version.sbom_ok": "SBOM téléchargé.",
  "v5.architecture.version.titre": "Architecture d’une version livrée",
  "v5.architecture.version.vuln_non_analyse": "Aucune analyse de vulnérabilités enregistrée pour cette version.",
  "v5.architecture.version.vuln_vide": "Aucune vulnérabilité relevée par la dernière analyse."
}
